<template>
  <div class="card-box main-box">
    <div
      class="productEditMc"
      v-show="productEditMcShow"
      @click="
        () => {
          stateVisible = true;
        }
      "
    ></div>
    <ul class="breadcrumb">
      <li>{{ $t("productClasses.breadcrumb1") }}</li>
      <li>{{ $t("productClasses.breadcrumb2") }}</li>
    </ul>
    <div class="historyBox">
      <div class="historyTitle" v-if="historyList.length != 0">{{ $t("productClasses.history") }} ></div>
      <ul
        class="history"
        v-for="(item, index) in historyList"
        :key="item.ClassIdList"
      >
        <li
          @click="selectHistory(item.ClassIdList, item.SonClassId)"
          :class="{ historyState: item.ClassIdList === historyClassIdList }"
        >
          {{ item.ClassName }}
          <span>{{
            index !== historyList.length - 1 && historyList.length !== 0
              ? "、"
              : ""
          }}</span>
        </li>
      </ul>
      <!-- <ul class="history">
        <li>宝贝管理</li>
      </ul>-->
    </div>
    <transition-group tag="div" name="menu" class="menu-box">
      <ul
        :class="['menu', 'card-box', 'scroll' + parseInt(index)]"
        v-for="(classes, index) in productClasses"
        :key="classes.key"
      >
        <li
          v-for="(productClass, i) in classes"
          :key="productClass.ClassId"
          :class="{ selected: indexsForSelectedProductClasses[index] === i }"
          @click="menuOnClick(index, i)"
        >
          {{ productClass.ClassName }}
          <i class="el-icon-arrow-right" v-if="productClass.isHValue"></i>
        </li>
      </ul>
    </transition-group>
    <div class="card-box select-box">
      <span>{{ $t("productClasses.selectText") }}：</span>
      <ul class="breadcrumb small">
        <li v-for="name in selectedClassesName" :key="name">{{ name }}</li>
      </ul>
    </div>
    <el-button type="primary" round class="submit-btn" @click="submitAction"
      >{{ $t("productClasses.submit") }}</el-button
    >
    <!-- 服务说明 -->
    <el-dialog
      class="stateBox"
      :visible.sync="stateVisible"
      min-width="50%"
      top="35vh"
      :center="true"
    >
      <div slot="title" class="title">{{ $t("productClasses.tips") }}</div>
      <div class="stateInfo">
        {{ $t("productClasses.text1") }}
      </div>
      <div class="stateInfo2">
        {{ $t("productClasses.text2") }}
      </div>
      <div class="stateInfo2" style="margin-top: 0px">
        {{ $t("productClasses.text3") }}
      </div>
      <div class="btns">
        <el-button class="stateInfoBt" type="success" @click="agreedSub" round
          >{{ $t("productClasses.confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  props: {
    stop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productClasses: [],
      indexsForSelectedProductClasses: [],
      historyList: [],
      historyClassIdList: "",
      productEditMcShow: false, // 显示服务协议按钮
      stateVisible: false, // 服务说明
    };
  },
  computed: {
    selectedClassesName: function () {
      let array = [];
      for (let i = 0; i < this.indexsForSelectedProductClasses.length; i++) {
        const selectedIndex = this.indexsForSelectedProductClasses[i];
        array.push(this.productClasses[i][selectedIndex].ClassName);
      }
      if (array.length === 0) {
        array.push(this.$t("productClasses.unselect"));
      }
      return array;
    },
  },
  created() {
    // this.request()
    console.log(111);
    this.releaseProductsIndex();
    // 20200523检测用户是否同意协议
    let agreedState = JSON.parse(localStorage.getItem("agreedState"));
    console.log(agreedState);
    if (!agreedState) {
      this.stateVisible = true;
      this.productEditMcShow = true;
      // return false
    }
  },
  mounted() {
    let aa = [1, 2];
    aa[3] = 6;
    console.log(aa);
  },
  // 点击加样式
  methods: {
    // 同意协议
    agreedSub() {
      localStorage.setItem("agreedState", false);
      this.stateVisible = false;
      this.productEditMcShow = false;
      // this.handleSubmit()
    },
    request(index = 0, parentID = null) {
      let param = {};
      if (parentID) {
        param.ParentId = parentID;
      }
      this.$api.product
        .loadProductClass(param)
        .then((res) => {
          // 生成key
          let data = res.data;
          data.key = index;
          this.productClasses.splice(
            index,
            this.productClasses.length - index,
            data
          );
          console.log(this.productClasses);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 初始化请求
    releaseProductsIndex(index = 0, parentID = null) {
      let param = {};
      if (parentID) {
        param.ParentId = parentID;
      }
      this.$api.product
        .releaseProductsIndex(param)
        .then((res) => {
          // 生成key
          let data = res.data.ProductClassList;
          // 数组去重
          let userProductClassList = res.data.UserProductClassList || [];
          let newUserProductClassList = userProductClassList.reduce(
            (total, item, index) => {
              // eslint-disable-next-line no-unused-expressions
              userProductClassList[item.ClassIdList]
                ? ""
                : (userProductClassList[item.ClassIdList] =
                    true && total.push(item));
              return total;
            },
            []
          );
          // this.historyList = res.data.UserProductClassList
          this.historyList = newUserProductClassList;
          data.key = index;
          this.productClasses.splice(
            index,
            this.productClasses.length - index,
            data
          );
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    menuOnClick(menuIndex, index) {
      // debugger
      if (this.indexsForSelectedProductClasses[menuIndex] === index) {
        return;
      }
      this.indexsForSelectedProductClasses.splice(
        menuIndex,
        this.indexsForSelectedProductClasses.length - menuIndex,
        index
      );
      const productClass = this.productClasses[menuIndex][index];
      if (productClass.isHValue) {
        this.request(menuIndex + 1, productClass.ClassId);
      } else {
        this.productClasses.splice(
          menuIndex + 1,
          this.productClasses.length - menuIndex - 1
        );
      }
    },
    submitAction() {
      const col = this.indexsForSelectedProductClasses.length - 1;
      console.log(this.indexsForSelectedProductClasses);
      // if (col === -1 || this.productClass !== 1) {
      if (col === -1) {
        this.$message.error(this.$t("productClasses.selectClass"));
        return;
      }
      const row = this.indexsForSelectedProductClasses[col];
      const productClass = this.productClasses[col][row];
      if (productClass.isHValue) {
        this.$message.error(this.$t("productClasses.selectClass"));
        return;
      }
      this.$emit("save", productClass);
      if (this.stop) return;
      this.$router.push({
        path: "productEdit",
        query: { id: productClass.ClassId },
      });
    },
    // 点击历史导入类目
    selectHistory(classIdList, sonClassId) {
      const newClassIdList = classIdList.split("|").map(Number);
      this.historyClassIdList = classIdList;
      this.$nextTick(() => {
        this.nextClassProduct(newClassIdList, 0);
      });
    },
    // 模仿点击类目方法
    nextClassProduct(newClassIdList, index) {
      console.log(this.productClasses);
      let promise = new Promise((resolve, reject) => {
        if (index < this.productClasses.length) {
          this.productClasses[index].forEach((findItem, findIndex) => {
            if (findItem.ClassId === newClassIdList[index]) {
              this.menuOnClick(index, findIndex);
              let data = {
                index: index,
                findIndex: findIndex,
              };
              resolve(data);
              reject(data);
            }
          });
        }
      });
      promise.then((data) => {
        // 432   37
        // console.log(data.findIndex)
        // console.log(data.index)
        this.$nextTick(() => {
          let scroll = ".scroll" + parseInt(data.index);
          console.log(scroll);
          document.querySelector(scroll).scrollTop = (data.findIndex - 5) * 37;
        });
        // if (data.findIndex > 5) {
        //   this.$nextTick(() => {
        //     let scroll = '.scroll' + parseInt(data.index)
        //     console.log(scroll)
        //     document.querySelector(scroll).scrollTop = (data.findIndex - 5) * 37
        //   })
        // }
        setTimeout(() => {
          this.nextClassProduct(newClassIdList, data.index + 1);
        }, 500);
      });
    },
    // 跳转服务条款
    toTerms() {
      this.$router.push("/terms");
    },
  },
};
</script>
<style  scoped lang="scss">
.menu-enter,
.menu-leave-active {
  opacity: 0;
  transform: translateY(-50px);
}

.main-box {
  padding: 30px;

  .menu-box {
    margin-top: 20px;

    .menu {
      width: 400px;
      height: 432px;
      margin: 0 0 0 20px;
      list-style: none;
      padding: 0;
      display: inline-block;
      overflow-y: scroll;
      transition: all 0.3s;

      &:first-child {
        margin-left: 0;
      }

      & > li {
        padding: 10px 12px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        font-size: 12px;
        cursor: pointer;
        &.selected {
          font-weight: bold;
          //background-color: #f6f6f6;
          background-color: #dedede;
        }

        i {
          margin-left: 6px;
        }
      }
    }
  }

  .select-box {
    margin-top: 16px;
    color: #333;
    font-size: 12px;
    padding: 20px;

    .breadcrumb {
      display: inline-block;
    }
  }

  .submit-btn {
    width: 300px;
    font-size: 12px;
    display: block;
    margin: 25px auto 0;
  }
  .historyBox {
    display: flex;
    align-items: center;
    margin: 10px 0;
    .historyTitle {
      font-size: 14px;
      font-weight: bold;
      margin-right:10px;
    }
    .history {
      display: block;
      list-style: none;
      padding: 0;
      margin: 0;
      font-size: 14px;
      font-weight: bold;
      color: #000;
      margin-right: 15px;
      cursor: pointer;
      li {
        display: inline-block;
        cursor: pointer;
        &::before {
          content: ">";
          padding: 0 5px;
        }
        &:first-child {
          &::before {
            content: none;
            padding: 0 5px;
          }
        }
      }
      .historyState {
        color: #22b196;
      }
    }
  }
}
.stateBox {
  text-align: center;
  ::v-deep .el-dialog--center {
    border-radius: 16px;
  }
  // ::v-deep .el-dialog--center .el-dialog__body{
  //  text-align: center !important;
  // }
  .stateInfo {
    margin: 0 auto;
    //  text-align: center;
    max-width: 800px;
    font-weight: bold;
    cursor: pointer;
    color: #e6a23c;
    font-size: 18px;
    text-indent: 1em;
  }
  .stateInfo2 {
    margin: 0 auto;
    //  text-align: center;
    max-width: 800px;
    margin-top: 30px;
    cursor: pointer;
    color: #909090;
    text-indent: 1em;
    line-height: 22px;
  }
  .stateInfoBt {
    margin: 0 auto;
    text-align: center;
    background-color: #22b196;

    font-weight: 500;
  }
  .btns {
    width: 100%;
    text-align: center;
    margin-top: 5%;
  }
  .title {
    font-weight: bold;
    font-size: 20px;
  }
}
.productEditMc {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 81%;
  right: 0;
  z-index: 3;
  // background-color: #000000;
  opacity: 0.6;
}
</style>
